import ResyRewardsBackgroundVideo from './ResyRewardsBackgroundVideo';

export default ResyRewardsBackgroundVideo;
